import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';

import PropTypes from 'prop-types';

import { GlobalEventListener } from 'ui-components/components/global-event-listener';

import {
  isScreenDesktop,
  isScreenMobile,
  isScreenTablet,
  isScreenWidescreen,
  isScreenUltrawide,
  isScreenUltraMobile,
} from '../constants/screen-width-breakpoints';

export const ScreenSizeContext = createContext({
  isUltraMobile: false,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isWidescreen: false,
  isUltrawide: false,
});
export const useScreenSizeContext = () => useContext(ScreenSizeContext);

export const ScreenSizeContextProvider = ({ children }) => {
  const [isUltraMobile, setIsUltraMobile] = useState(isScreenUltraMobile);
  const [isMobile, setIsMobile] = useState(isScreenMobile);
  const [isTablet, setIsTablet] = useState(isScreenTablet);
  const [isDesktop, setIsDesktop] = useState(isScreenDesktop);
  const [isWidescreen, setIsWidescreen] = useState(isScreenWidescreen);
  const [isUltrawide, setIsUltrawide] = useState(isScreenUltrawide);

  const evaluateScreenSize = useCallback(() => {
    setIsUltraMobile(isScreenUltraMobile());
    setIsMobile(isScreenMobile());
    setIsTablet(isScreenTablet());
    setIsDesktop(isScreenDesktop());
    setIsWidescreen(isScreenWidescreen());
    setIsUltrawide(isScreenUltrawide());
  }, []);

  const value = useMemo(
    () => ({
      isUltraMobile,
      isMobile,
      isTablet,
      isDesktop,
      isWidescreen,
      isUltrawide,
    }),
    [isUltraMobile, isMobile, isTablet, isDesktop, isWidescreen, isUltrawide],
  );

  return (
    <>
      <ScreenSizeContext.Provider value={value}>
        <GlobalEventListener onResize={evaluateScreenSize}>{children}</GlobalEventListener>
      </ScreenSizeContext.Provider>
    </>
  );
};

ScreenSizeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
